import { PureComponent } from 'react';
import PropTypes from 'prop-types';

import JLCheckbox from 'jl-design-system/components/checkbox/Checkbox';

export class Checkbox extends PureComponent {
  render() {
    const { id, checkboxText, disabled, checked, onChange } = this.props;

    return (
      <JLCheckbox
        id={id}
        name={id}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        label={checkboxText}
      />
    );
  }
}

Checkbox.propTypes = {
  id: PropTypes.string.isRequired,
  checkboxText: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
};

Checkbox.defaultProps = {
  disabled: false,
};
